import {lazy} from "react";

export const VoyageTemplatesSingleVoyageLazy = lazy(() => import('./VoyageTemplatesSingleVoyage'))
